<template>
  <div class="name">

    <!-- <el-row class="bgW">
      <el-col :span="20">
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="产品名称">
            <el-input
              v-model="search.name"
              maxlength="30"
              clearable
              placeholder="请输入产品名称"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="search.status" clearable placeholder="请选择状态">
              <el-option
                v-for="item in options.statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <el-button type="primary" size="mini" @click="getList('resetForm')">重置</el-button>
      </el-col>
    </el-row> -->
    <div>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog">添加</el-button>
    </div>
    <div class="accountCon">
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <el-table-column label="序号" type="index" width="55" />
            
            <el-table-column
              v-for="item in title"
              :key="item.value"
              :label="item.label"
              v-bind="getColumnAttr(item.value)"
            >
              <template slot-scope="{ row }">
                <el-switch
                  v-if="item.value === 'status'"
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="启用"
                  inactive-text="禁用"
                  @change="handleStatusChange(row)"
                />
                <span v-else-if="isTube(item.value)">{{ formatTube(row[item.value]) }}</span>
                <span v-else>{{ row[item.value] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.pagesize"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="新增复合组合"
      :visible.sync="dialogVisible"
      width="45%"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <div class="compound-header">
        <div class="form-item">
          <span class="form-label">价格：</span>
          <el-input
            v-model="formPrice"
            controls-position="right"
            size="small"
            class="header-price"
          />
        </div>
        <div class="form-item">
          <span class="form-label">备注：</span>
          <el-input
            v-model="formRemark"
            placeholder="请输入备注"
            size="small"
            type="textarea"
            class="header-remark"
          />
        </div>
      </div>
      <div class="compound-wrap">
        <div v-for="(group, gIndex) in goodsList" :key="group.tube_id || gIndex" class="tube-block">
          <div class="tube-head">
            <span class="tube-name">{{ group.tube_name }}</span>
          </div>
          <el-table
            :data="group.material_list"
            size="mini"
            :header-cell-style="{'text-align':'center'}"
            class="tube-table"
          >
            <el-table-column label="产品选择" width="220" align="center">
              <template slot-scope="{ row }">
                <el-select
                  v-model="row.material_id"
                  placeholder="请输入产品搜索"
                  size="mini"
                  filterable
                  class="select-inline"
                  clearable
                  @change="onMaterialChange(row)"
                >
                  <el-option
                    v-for="item in options.materialList"
                    :key="item.id"
                    :label="item.code + ' ' + item.name"
                    :value="item.id"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="产品规格" width="120" align="center">
              <template slot-scope="{ row }">
                {{ row.spec }}
              </template>
            </el-table-column>
            <el-table-column label="产品数量" width="120" align="center">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.quantity"
                  :min="1"
                  :step="1"
                  :precision="0"
                  controls-position="right"
                  size="mini"
                  class="qty-inline"
                />
              </template>
            </el-table-column>
            <el-table-column label="产品价格" width="110" align="center">
              <template slot-scope="{ row }">
                {{ (row.quantity * row.price).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="{ $index }">
                <el-button
                  v-if="group.material_list.length > 1 && gIndex !== 0"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  :disabled="readonly"
                  circle
                  @click="removeMaterial(gIndex, $index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            v-if="gIndex !== 0"
            type="text"
            icon="el-icon-plus"
            size="mini"
            @click="addMaterial(gIndex)"
          >添加产品</el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm">确认保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/components/Pagination'
import { getMaterialList,getProductList, createProduct, updateProductStatus, getTubeList } from '@/api/goods'

class Page {
  total = 0;
  page = 1;
  pagesize = 10;
}
class Search {
  name = ''; // 搜索内容
  status = ''; // 1启用 2禁用
}
class Options {
  statusList = [
    { label: '启用', value: 1 },
    { label: '禁用', value: 2 }
  ];
  materialList = []; // 可选产品（openDialog 时预加载）
}
// 单个品类分组（由 getTubeList 初始化）
class TubeGroup {
  constructor(tube_id, tube_name) {
    this.tube_id = tube_id;
    this.tube_name = tube_name;
    this.material_list = [{ material_id: '', quantity: 1, price: 0, spec: '' }];
  }
}
export default {
  name: 'CompoundProductList',
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(),
      page: new Page(),
      options: new Options(),
      list: [],
      title: [],
      dialogVisible: false,
      goodsList: [new TubeGroup()],
      formPrice: 0,
      formRemark: ''
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 格式化管数据：[{ material_code, quantity }] → "F-06×30, E-05×6"
    formatTube(tubeData) {
      if (!tubeData || !tubeData.length) return '-';
      return tubeData.map(t => t.material_code + '×' + t.quantity).join(', ');
    },
    isTube(value) {
      return /^tube_\d+$/.test(value);
    },
    getColumnAttr(value) {
      const attr = { prop: value };
      if (value === 'status') attr.width = 150;
      if (value === 'price') attr.width = 120;
      if (value === 'tube_1') attr.width = 120;
      if (value === 'remark') attr.showOverflowTooltip = true;
      return attr;
    },
    // 获取列表
    getList(option) {
      if (option === 'resetForm') { this.search = new Search(); this.page = new Page(); }
      if (option === 'search') this.page = new Page();
      getProductList({ ...this.search, ...this.page }).then(res => {
        this.list = res.data.list;
        const title = res.data.title || [];
        this.title = title.map(t =>
          typeof t === 'string'
            ? { value: t, label: t }
            : { value: t.value, label: t.lable }
        );
        this.page.total = res.data.dataCount;
      });
    },
    // 打开新增弹窗
    async openDialog() {
      if (!this.options.materialList.length) {
        getMaterialList({ is_select: 1 }).then(res => {
          this.options.materialList = (res.data && res.data.list) || res.list || [];
        });
      }
      try {
        const res = await getTubeList();
        const tubeList = (res && (res.list || (res.data && res.data.list) || res.data)) || [];
        this.goodsList = tubeList.map(t => new TubeGroup(t.id, t.name));
      } catch (e) {
        this.goodsList = [];
        this.$message.error('获取品类列表失败');
      }
      this.dialogVisible = true;
    },
    resetForm() {
      this.goodsList = [];
      this.formPrice = 0;
      this.formRemark = '';
    },
    addMaterial(gIndex) {
      if (gIndex === 0) {
        return this.$message.warning('甲管只能有一个产品');
      }
      this.goodsList[gIndex].material_list.push({ material_id: '', quantity: 1, price: 0, spec: '' });
    },
    removeMaterial(gIndex, mIndex) {
      this.goodsList[gIndex].material_list.splice(mIndex, 1);
    },
    // 选中产品自动同步规格、价格
    onMaterialChange(row) {
      if (!row.material_id) {
        row.spec = '';
        row.price = 0;
        return;
      }
      const item = this.options.materialList.find(x => x.id === row.material_id);
      if (item) {
        row.spec = item.spec || '';
        row.price = item.price || 0;
      }
    },
    // 保存
    submitForm() {
      if (!this.goodsList.length) {
        return this.$message.warning('暂无品类数据');
      }
      const validGroups = [];
      for (const g of this.goodsList) {
        const validRows = [];
        const matIds = [];
        for (const m of g.material_list) {
          if (!m.material_id) continue; // 跳过空行
          if (matIds.includes(m.material_id)) {
            return this.$message.warning('「' + g.tube_name + '」下产品不能重复');
          }
          matIds.push(m.material_id);
          if (!m.quantity || m.quantity < 1) {
            return this.$message.warning('数量必须大于1');
          }
          validRows.push({ material_id: m.material_id, quantity: m.quantity });
        }
        if (validRows.length) {
          validGroups.push({ tube_id: g.tube_id, material_list: validRows });
        }
      }
      if (!validGroups.length) {
        return this.$message.warning('请至少为一个管添加产品');
      }
      createProduct({ goodsList: validGroups, remark: this.formRemark, price: this.formPrice }).then(res => {
        this.$message({
          type: 'success',
          message: res.msg || '添加成功'
        });
        this.dialogVisible = false;
        this.getList('search');
      });
    },
    // 上下架/启用禁用
    handleStatusChange(row) {
      updateProductStatus({ id: row.id, status: row.status }).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        });
      }).catch(() => {
        row.status = row.status === 1 ? 2 : 1;
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.accountCon {
  background: #fff;
  padding: 10px 0 80px;
}
.compound-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 12px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
  .form-item {
    display: flex;
    align-items: center;
    .form-label {
      font-size: 13px;
      color: #606266;
      font-weight: 600;
      margin-right: 6px;
    }
    .header-price {
      width: 120px;
    }
    .header-remark {
      width: 260px;
    }
  }
}
.compound-wrap {
  max-height: 55vh;
  overflow-y: auto;
  padding-right: 6px;
}
.tube-block {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  .tube-head {
    margin-bottom: 10px;
    .tube-name {
      font-weight: 600;
      font-size: 14px;
      color: #303133;
    }
  }
  .tube-table {
    margin-bottom: 6px;
    .select-inline {
      width: 200px;
    }
    .qty-inline {
      width: 100px;
    }
  }
}
.header-center {
  text-align: center !important;
}
</style>
